<template>
  <div class="PersonalCard">
    <div class="heard">乘客</div>
    <van-collapse v-model="activeNames">
      <van-collapse-item name="1">
        <slot slot="title" name="title">
          <div class="name">
            <span>{{item.name}}</span>
          </div>
        </slot>
        <div class="content">
          <div class="top">身份证号</div>
          <div class="bottom">{{item.IdCard}}</div>
        </div>
      </van-collapse-item>
    </van-collapse>
  </div>
</template>
<script>
import { Collapse, CollapseItem } from 'vant'
export default {
  data () {
    return {
      activeNames: ['']
    }
  },
  props: {
    item: {
      type: Object
    }
  },
  components: {
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem
  }
}
</script>
<style scoped lang="less">
.PersonalCard {
  width: 702px;
  // height: 384px;
  background-color: #fff;
  border-radius: 8px;
  padding: 20px 24px 0px;
  margin-bottom: 16px;
  box-sizing: border-box;
  /deep/.van-cell:not(:last-child)::after{
        border-bottom: 1px solid #ECEEF1;
        left: 0px;
      }
  .heard {
    color: #9ea9b9;
    font-size: 24px;
    margin-bottom: 12px;
  }
  /deep/.van-collapse-item__content {
    padding: 16px 0px;
  }
  /deep/.van-cell__right-icon{
    color: #9EA9B9;
    font-size: 14px;
    font-weight: bold;
  }
  /deep/.van-cell {
    padding: 0px;
    height: 40px;
    line-height: 40px;
    .van-icon {
      height: 40px;
      line-height: 40px;
    }
  }
  /deep/[class*=van-hairline]::after{
        border: none;
        border-bottom: 1px solid #ECEEF1;
    }
  .content {
    div {
      text-align: left;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .top {
      color: #9ea9b9;
      font-size: 24px;
      margin-bottom: 10px;
    }
    .bottom {
      color: #3e4966;
      font-size: 28px;
      font-weight: 400;
    }
    .center {
      flex-grow: 1;
    }
  }
}
.name {
  height: 40px;
  color: #3e4966 !important;
  span:nth-of-type(1) {
    width: 200px;
    font-size: 36px;
    font-weight: 700;
    font-family: "Bahnschrift","PingFang SC";
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>
